export const SUPPORT_EMAIL = "benji.lightstone@gmail.com";

export const APP_NAME = "frndly";

export const WEB_URL = "https://frndly.vercel.app";
